<template>
  <section class="product-panel mt-4 mb-4" v-if="sales && sales.length > 0">
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id"/>
      </div>
    </modal>
    <modal id="addCartModalOnSale" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">
              {{ translations.goToShoppingCart }}
            </button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{ translations.continueShopping }}
          </button>
        </div>
      </div>
    </modal>
    <div class="section-title">
      <h2>{{ translations.articlesOnSale }}</h2>
    </div>
    <VueSlickCarousel v-bind="slickSettings">
      <div
        class="product-wrapper product-default inner-quickview inner-icon product-item"
        v-for="item in sales"
        :key="item.id"
      >
        <figure>
          <router-link
            :to="{ name: 'Article',
              params: { id: item.articleId, slug: slugify(item.title) }
            }">
            <Photo :src="`${baseUrl}${item.highlightedImageUrl}`" v-if="item.highlightedImageUrl" />
            <Photo src="assets/images/no-image.jpg" v-else />
          </router-link>
          <div
            class="label-group"
            v-if="item.salePrice < item.originalPrice && item.salePrice"
          >
            <span class="product-label label-cut">
              -{{ item.discount | percentage }}% </span>
          </div>
          <div class="btn-icon-group" v-if="!item.disableSelling">
            <button class="btn-icon btn-add-cart" @click="addToCart(item)">
              <i class="sicon-equalizer" v-if="item.hasAttributes" />
              <i class="icon-bag" v-else />
            </button>
          </div>
          <button
            class="btn btn-sm btn-quickview"
            data-toggle="modal"
            @click="getQuickArticle(item.articleId)"
          >
            {{ translations.quickPreview }}
          </button>
        </figure>
        <div class="product-details">
          <div class="category-wrap">
            <div class="category-list">
              <router-link :to="{ name: 'Brand',
               params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-') } }">
                {{ item.brandTitle }}
              </router-link>
            </div>
            <a
              class="btn-icon-wish"
              :class="{ active: item.isOnWishList }"
              @click.prevent.stop="toggleWishlistItem(item.articleId)"
            >
              <i class="icon-heart" :class="{ 'icon-heart-1': item.isOnWishList }"></i>
            </a>
          </div>
          <h2 class="product-title" :title="item.title">
            <router-link
              :to="{
                name: 'Article',
                params: {
                  id: item.articleId,
                  slug: slugify(item.title)
                }
              }">
              {{ item.title }}
            </router-link>
          </h2>
          <div class="ratings-container">{{ translations.forms.labels.code }}: {{ item.code }}</div>
          <div class="price-box" v-if="canViewPrices && !item.disableSelling">
            <span class="product-price">
              {{ (item.salePrice || item.originalPrice) | money3WithCurrency }}</span>
            <span
              class="old-price"
              v-if="item.salePrice < item.originalPrice && item.salePrice"
            >
              {{ item.originalPrice | money3 }} KM
            </span>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
    <div class="row row-sm flex-row justify-content-end px-4 font-weight-bold">
      <router-link :to="{ name: 'Sales' }">
        {{ translations.viewAll }}
      </router-link>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import './slick.css';

import config from '@/config';
import { translations } from '@/mixins';
import Photo from '@/components/shared/Image.vue';
import api from '@/services/api';
import slugify from '@/filters/slugify';
import helpers from '@/services/helpers';

import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';

export default {
  name: 'ArticleOnSales',
  mixins: [translations],
  components: {
    VueSlickCarousel,
    Photo,
    Modal,
    QuickPreview,
  },
  data() {
    return {
      slickSettings: {
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        swipeToSlide: true,
        autoplay: true,
        speed: 1000, // speed of scroll
        autoplaySpeed: 10000, // scroll every 10 sec
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      selectedArticle: null,
    };
  },
  computed: {
    sales() {
      return this.$store.getters.getArticlesOnSale;
    },
    baseUrl() {
      return config.baseUrl;
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        // this.$store.dispatch('getNewlyAddedArticles');
        this.$store.dispatch('getWishList');
      });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.articleId, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.articleId,
          quantity: item.minOrderQuantity || 1,
        })
        .then(() => {
          this.$toast.info(helpers.getAddToCartToastMessage(item));
          this.$store.dispatch('getShoppingCart');
        }).catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
          this.$store.dispatch('getShoppingCart');
          $('#addCartModalOnSale').modal('hide');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getArticlesOnSale', {
      isSortAscending: false,
      retrieveAll: true,
    });
  },
};
</script>
<style lang="scss" scoped>
.product-wrapper {
  padding: 15px;
  border-right: 1px solid #e7e7e7;
  &:last-child {
    border-left: none;
  }
}

.product-default .product-title,
.product-default a {
  display: block;
  width: 100%;
}

.btn-icon-wish {
  cursor: pointer;

  &.active {
    color: red;
  }
}

.product-item {
  .product-details {
    min-height: 135px !important;
    justify-content: flex-start;
  }
}

.html-content a {
  color: #3598DB;
}
</style>
